import Button from '@ui/buttons/button/button';
import Checkbox from '@ui/checkbox/checkbox';
import Container from '@ui/container/container';
import OptionalComponent from '@ui/optional-component/optional-component';
import Text from '@ui/text/text/text';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import { ICONS } from '@ui/icons/types';
import getProjectOverChannelColorCssVariable from '@/utils/colors/get-project-over-channel-color-css-variable';

import styles from './language-selector-option.module.css';

type TLanguageSelectorOptionProps = {
  data: TReactSelectOption;
  isFocused: boolean;
  isSelected: boolean;
  defaultLanguage: string;
  hideBaseSelector?: boolean;
  onBaseSelect?: (data: TReactSelectOption) => void;
};

const LanguageSelectorOption = ({
  onBaseSelect,
  data,
  defaultLanguage,
  hideBaseSelector,
  isSelected,
  isFocused,
}: TLanguageSelectorOptionProps) => {
  const isDefaultLanguage = data.value === defaultLanguage;

  const baseTextColor = getProjectOverChannelColorCssVariable(EColorVariablesV2.primary, 'global-cont-3');

  return (
    <Container height="100%" width="100%" className="flex jc-space-between ai-center position-relative cursor-pointer">
      <Checkbox
        inert
        value={data.value}
        checked={isSelected}
        unselectedIconName={ICONS.CHECKBOX_SWOOSH}
        selectedIconName={ICONS.CHECKBOX_SWOOSH_CHECKED}
        size={12}
      />
      <img
        src={`${import.meta.env.VITE_ASSET_SERVER}/flags/round/${data.value}.svg`}
        alt={data.label}
        className="square-12 margin-l-8"
      />
      <Text design="GlobalIcoText1" className="L3 flex-1 margin-l-8" width="100%" clamp={1} wordBreak="break-all">
        {data.label.toString()}
      </Text>
      <OptionalComponent display={isDefaultLanguage}>
        <Text design="GlobalIcoText3" className="L3">
          BASE LANGUAGE
        </Text>
      </OptionalComponent>
      <OptionalComponent display={!isDefaultLanguage && isFocused && !hideBaseSelector}>
        <Button
          borderRadius="4px"
          className={`L3 padding-h-4 flex-column jc-center ${styles['select-base-language-button']}`}
          clear
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onBaseSelect?.(data);
          }}
        >
          <Text color={baseTextColor}>Set as base</Text>
          <Container
            height="1px"
            width="100%"
            className={styles['select-base-language-button-underline']}
            border={`1px solid ${baseTextColor}`}
          />
        </Button>
      </OptionalComponent>
    </Container>
  );
};

export default LanguageSelectorOption;
